import { AddClientRequest, Client } from '../types';
import apiClient from './apiClient';

const CLIENT_KEY = 'clients';

const addClient = async (request: AddClientRequest) => {
	const response = await apiClient.post<Client>('/auth/clients', request);
	return response.data;
};

const getClient = async (clientId: string) => {
	const response = await apiClient.get<Client>(`/auth/clients/${clientId}`);
	return response.data;
};

const getClients = async () => {
	const response = await apiClient.get<Client[]>('/auth/clients');
	return response.data;
};

const deleteClient = async (clientId: string) => {
	const response = await apiClient.delete(`/auth/clients/${clientId}`);
	return response.data;
};

const regenerateClientSecret = async (clientId: string) => {
	const response = await apiClient.put<string>(
		`/auth/clients/${clientId}/regenerateSecret`,
	);
	return response.data;
};

const ClientsApi = {
	addClient,
	getClient,
	getClients,
	deleteClient,
	regenerateClientSecret,
	CLIENT_KEY,
};

export default ClientsApi;
